<div class="space-y-6 p-6">
  <!-- Page Header -->
  <div class="mb-6">
    <h1 class="mb-2 text-2xl font-bold text-gray-900 dark:text-white">
      {{ 'dashboard.title' | translate }}
    </h1>
    <p class="text-gray-600 dark:text-gray-400">
      {{ 'dashboard.subtitle' | translate }}
    </p>
  </div>

  <!-- Top Row - Coming Soon Cards -->
  <!--   <div class="mb-6 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
    <app-stat-card
      [value]="'common.comingSoon' | translate"
      [label]="'dashboard.placeholder.card1' | translate"
      icon="pi-chart-line"
      color="indigo"
    >
    </app-stat-card>

    <app-stat-card
      [value]="'common.comingSoon' | translate"
      [label]="'dashboard.placeholder.card2' | translate"
      icon="pi-chart-bar"
      color="amber"
    >
    </app-stat-card>

    <app-stat-card
      [value]="'common.comingSoon' | translate"
      [label]="'dashboard.placeholder.card3' | translate"
      icon="pi-chart-pie"
      color="green"
    >
    </app-stat-card>

    <app-stat-card
      [value]="'common.comingSoon' | translate"
      [label]="'dashboard.placeholder.card4' | translate"
      icon="pi-trending-up"
      color="blue"
    >
    </app-stat-card>
  </div> -->

  <!-- Main Content Grid -->
  <div class="grid grid-cols-1 items-stretch gap-6 lg:grid-cols-2">
    <!-- Today's Metrics -->
    <app-todays-metrics></app-todays-metrics>

    <!-- Issue Overview -->
    <app-issue-overview></app-issue-overview>

    <!-- Property Summary -->
    <!-- <app-property-summary></app-property-summary> -->

    <!-- Quick Navigation -->
    <!--     <app-quick-navigation></app-quick-navigation> -->
  </div>

  <!-- Charts Section -->
  <div class="grid grid-cols-1 items-stretch gap-6 lg:grid-cols-2">
    <!-- Check-in Ratio Chart -->
    <app-checkin-ratio-chart></app-checkin-ratio-chart>

    <!-- App Usage Chart -->
    <app-app-usage-chart></app-app-usage-chart>

    <!-- Starting Bookings Chart -->
    <app-starting-bookings-chart></app-starting-bookings-chart>

    <!-- Occupied Flats Chart -->
    <app-occupied-flats-chart></app-occupied-flats-chart>

    <!-- Parking Utilization Chart -->
    <app-parking-utilization-chart></app-parking-utilization-chart>

    <!-- Actual Cleaning Schedules Chart -->
    <app-cleaning-schedules-chart></app-cleaning-schedules-chart>

    <!-- Cleaning Requests Chart -->
    <app-cleaning-requests-chart></app-cleaning-requests-chart>
  </div>
</div>
